export enum checkoutTypes {
  PRODUCT = "product",
  CART = "cart"
}